import { createAction } from "@reduxjs/toolkit";
import { typePagination, typeRequestPagination } from "../system/constants";
import {
  typeRefundsArchiveFilters,
  IdRefundsArchiveStateDataItem,
} from "./reducer";

const prefix = "D_REFUNDS_ARCHIVE";

export const dRefundsArchiveSetDataAC = createAction(
  `${prefix}_SET_DATA`,
  (dataList: IdRefundsArchiveStateDataItem[]) => ({ payload: { dataList } }),
);

export const dRefundsArchiveSetDataSagaAC = createAction(
  `${prefix}_SET_DATA_SAGA`,
  (
    filters: typeRefundsArchiveFilters,
    paginationRequest: typeRequestPagination,
  ) => ({
    payload: { filters, paginationRequest },
  }),
);

export const dRefundsArchiveSetDetailItemAC = createAction(
  `${prefix}_SET_DETAIL_ITEM`,
  (detailItemId: string) => ({ payload: detailItemId }),
);

export const dRefundsArchiveSetDetailItemFromSalesAC = createAction(
  `${prefix}_SET_DETAIL_ITEM_FROM_SALES`,
  (detailItem: any) => ({ payload: detailItem }),
);

export const dRefundsArchiveClearFiltersAC = createAction(
  `${prefix}_CLEAR_FILTERS`,
);

export const dRefundsArchiveSetFiltersAC = createAction(
  `${prefix}_SET_FILTERS`,
  (filtersObject: typeRefundsArchiveFilters) => ({ payload: filtersObject }),
);

export const dRefundsArchiveSetPaginationAC = createAction(
  `${prefix}_SET_PAGINATION`,
  (pagination: typePagination) => ({ payload: { pagination } }),
);

export const dRefundsArchiveSetItemsForPageAC = createAction(
  `${prefix}_SET_ITEMS_FOR_PAGE`,
  (itemsForPage: number) => ({ payload: { itemsForPage } }),
);

export const dRefundsArchiveSetPageNumberAC = createAction(
  `${prefix}_SET_PAGE_NUMBER`,
  (pageNumber: number) => ({ payload: { pageNumber } }),
);
